/* eslint-disable max-len */
import React, { Fragment, useCallback } from 'react'
import TableBody from './TableBody'
import { useDispatch,useSelector } from 'react-redux';
import { useState } from 'react';
import {toggleRowSelection,selectAllStudents,resetState} from '../../ModifyAttendance/StudentAttendanceSlice'

export default function Table({
    recodes, 
    searchParams,
    pageNumber,
    limit,AY_status, 
    List,
    tableContainerRef,
    emptyScreenMessage,
    pageType}) {
    const dispatch=useDispatch()
    const selectedRows=useSelector((state)=>state.StudentsIdSlice.selectedRows)
    
   
    const getRowId = useCallback((item) => (
        pageType === "staff" ? (item?.employee_id) : item?.student_id
    ), [pageType]);

    const allStudentIdsPerPage = recodes?.map((item) => ({pageNumber:pageNumber,id: getRowId(item)}));

    const handleCheckboxChange = (student_id) => {
        
        dispatch(toggleRowSelection([student_id,pageNumber,limit,recodes?.length,recodes]))

    };

    const handleAllRowsSelect=(event)=>{
        const paramstoPass=[event.target.checked,allStudentIdsPerPage,pageNumber,limit]
        dispatch(selectAllStudents(paramstoPass))
        
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;
    
    return (
        <>  
            <div className='-mx-1'>
                <div className={`flex overflow-auto pb-[6px] scroll-bar px-1`} id = "search-result" >
                    <table aria-label="Outside Table" class="w-full" id="admin-table">
                        <thead>
                            <tr>
                                <th class="w-[3%]">
                                    <div className={`relative checkbox custom-checkBoxBlue1${(List?.data?.length === 0 || List?.total_count === 0 || emptyScreenMessage === "No data found" || noSearchOrFilter)?"Disabled":""}`}>
                                        <input type="checkbox" id={pageNumber} data-testid="text-box" disabled={(List?.data?.length === 0 || List?.total_count === 0 || emptyScreenMessage === "No data found" || noSearchOrFilter)} checked={selectedRows?.topCheckBox?.find(item=>item.page_number===pageNumber)?.isChecked} onChange={handleAllRowsSelect}/>
                                        <label for={pageNumber} ></label>
                                    </div>
                                </th>
                                <th class="w-[14%]" >
                                    <span class="flex items-center justify-start ">
                                        {pageType === "staff" ? "Employee ID" : "Student ID"}
                                    </span>
                                </th>
                                <th className={`${pageType === "staff"?'w-[20%]':'w-[21%]'}`}>
                                    <span class="flex items-center justify-start">
                                        {pageType === "staff" ? "Employee Name" : "Student Name"}
                                    </span>
                                </th>
                                <th className={`${pageType === "staff"?'w-[11%]':'w-[9%]'}`}>
                                    <span class="flex items-center justify-start">
                                        {pageType === "staff" ? "Type" : "Gender"}
                                    </span>
                                </th>
                                <th class="w-[43%] colspan" colspan="4">
                                    <span class="flex items-center justify-center ">Attendance Summary
                                    </span>
                                </th>
                                <th class="w-[9%]">
                                    <span class="flex items-center justify-center ">Action
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr id="secondHeader">
                                <td class="text-start"></td>
                                <td class="text-start"></td>
                                <td class="text-start"></td>
                                <td class="text-start"></td>
                                <td class="font-semibold text-end border-l border-[#EDEDED] colspan">Total Days</td>
                                <td class="font-semibold text-end colspan">Present</td>
                                <td class="font-semibold text-end colspan-end">Percentage</td>
                                <td class="font-semibold text-end colspan">Absent</td>
                                <td class="text-center border-l border-[#EDEDED]"></td>
                            </tr>
                            {/* repit */}
                            
                            {List?.data?.length > 0 && recodes?.map((item) => (
                                
                                <Fragment key={item.id}>
                                    <TableBody 
                                        item={item} 
                                        searchParams={searchParams} 
                                        selectedRows={selectedRows.studentId} 
                                        handleCheckboxChange={handleCheckboxChange}
                                        AYStatus = {AY_status}
                                        pageType={pageType}
                                    />
                                </Fragment>))}
                        </tbody>
                        {(List?.data?.length === 0 || List?.total_count === 0 || emptyScreenMessage === "No data found" || noSearchOrFilter) && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px'}} colspan="9" className="no-records-message" id='no-matching-result'>
                                        {noSearchOrFilter ? (pageType === "staff" ? `Select 'Financial Year' and 'Employee Type' to view Employee Attendance.`:`Select 'Academic Year', 'Class', and 'Section' to view Student Attendance.`) : 'No matching records found.'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>            
                </div>
            </div>
        </>
        
    )
}
